import { createReducer } from '@reduxjs/toolkit';
import { usersInitialState } from './state';
import { changeUserAuditLogAction, changeUserRoleAction } from './actions';
import { UserData } from '../../types';

export const userReducer = createReducer<UserData>(usersInitialState, (builder) => {
  builder.addCase(changeUserAuditLogAction, (state, { payload }): UserData => {
    return {
      ...state,
      lastLogin: payload,
    };
  });

  builder.addCase(changeUserRoleAction, (state, { payload }): UserData => {
    return {
      ...state,
      role: payload,
    };
  });
});
